import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine18 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24 12.0002C24 18.6275 18.6276 24 12.0002 24C5.37249 24 0 18.6275 0 12.0002C0 5.37285 5.37249 0 12.0002 0C18.6276 0 24 5.37285 24 12.0002Z",
			fill: "#00A092"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.00232 18.3448V8.35234C6.22812 8.96456 5.00442 9.55875 4.15805 9.93683L3.29365 7.9923C4.62634 7.4342 6.22812 6.58783 7.48865 5.63361H9.70303V18.3448H7.00232ZM15.9125 18.6868C13.0855 18.6868 11.4837 16.9945 11.4837 15.068C11.4837 13.3757 12.4376 12.3132 13.662 11.6833C12.5638 10.9989 11.8798 10.1349 11.8798 8.82062C11.8798 6.71411 13.7883 5.25552 15.9666 5.25552C18.199 5.25552 20.0533 6.35369 20.0533 8.53236C20.0533 9.72073 19.4415 10.7291 18.2531 11.4492C19.4235 12.0073 20.4495 13.0874 20.4495 14.7621C20.4495 17.1745 18.523 18.6868 15.9125 18.6868ZM15.6967 12.5654C14.8684 12.8893 14.0401 13.7898 14.0401 14.7801C14.0401 15.8242 14.7241 16.8145 15.9485 16.8145C17.155 16.8145 17.8209 15.9681 17.8209 14.9601C17.8209 13.8079 16.7769 13.1054 15.6967 12.5654ZM16.0027 7.09219C15.012 7.09219 14.3821 7.70404 14.3821 8.58648C14.3821 9.63053 15.4261 10.2788 16.2364 10.6208C16.9024 10.3149 17.6232 9.48659 17.6232 8.69434C17.6232 7.81228 17.0467 7.09219 16.0027 7.09219Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine18);
export { ForwardRef as ReactComponent };
